<template>
  <div class="container">
      <div class="title0">
        <router-link :to="{path:'/'}"><img :src="url+'/img/xaiofei/sy.png'" class="return" /></router-link>
        <img :src="url+'/img/xaiofei/fh.png'" class="return" @click="clickReturn" />
        <img :src="url+'/img/zhibo/gx.png'" class="guang1" />
        <img :src="url+'/img/zhibo/gx.png'" class="guang2" />
      </div>
      <div class="content">
        <!-- 左侧导航 -->
        <!-- <div class="navBox">
          <div class="navLeft  animate__animated animate__fadeInLeft" :class="isShow? '' : 'left1'">
            <div :class="isShow? 'leftLeft' : 'leftLeft1'">
              <router-link :to="{path:'/xiaofei'}"><div class="btn btn2" ><span>电商直播</span></div></router-link>
              <router-link :to="{path:'/xiaofeiData'}"><div class="btn btn1"><span>电商大数据</span></div></router-link>
             <router-link :to="{path:'/xiaofeiChanpin'}"> <div class="btn btn2"><span>电商产品</span></div></router-link>
             <router-link :to="{path:'/zhibo'}"> <div class="btn btn2"><span>电商直播看板</span></div></router-link>
            </div>
            <img src="../assets/img/xaiofei/jt.png" class="jiantou" :class="!isShow?'jiantou1':''" @click="close" />
          </div>
        </div> -->
        <!-- 左侧 -->
        <div class="leftBox">  
          <div class="leftBox1">
            <router-link :to="{path:'/zhibo'}"><div class="title"><div class="titleBg">网络销售行业数据分析</div><img :src="url+'/img/jiantou.gif'" /></div></router-link>
            <div class="leftContent"><leftPie/></div>
            <div class="leftContent"><leftLine/></div>
          </div>
          <div class="leftBox2">
            <router-link :to="{path:'/xiaofeiChanpin'}"><div class="title"><div class="titleBg">农产品品类分布</div><img :src="url+'/img/jiantou.gif'" /></div></router-link>
            <div class="imgBox"><img :src="url+'/img/xaiofei/data/dz.gif'" /><img :src="url+'/img/xaiofei/data/dz.gif'" /></div>
            <div class="leftContent">
              <leftBar/>
            </div>
          </div>
          <div class="leftBox3">
            <div class="title"><div class="titleBg">县区网销列表</div></div>
            <div class="leftContent"><dv-scroll-board :config="config" style="width:100%;height:100%" /></div>
          </div>
        </div> 
         <!--中间地图  -->
        <div class="center">
          <!-- <div class="videoBg">
            <div class="videoBox" id="video">
              <vue3VideoPlay  width="100%"  height="100%"  :src="options.src"  :type="options.type"  :autoPlay="true"  :control="false"  :controlBtns="false" />
              <div class="ball"></div>
            </div>
          </div> -->
           <!-- 中心物体 -->
          <div class="cernterBg">
            <div class="centerContent">
                <img :src="url+'/img/xaiofei/data/s-sxt.png'" class="centerImg" />
                <div class="orbit">
                <!-- // 轨道上的物体 -->
                <div class="item item1">
                  <router-link :to="{path:'/xfksh'}"><img :src="url+'/img/xaiofei/data/cp.png'"  /><h5>电商产品</h5></router-link>
                </div>
                <div class="item item2"><router-link :to="{path:'/xfksh'}"><img :src="url+'/img/xaiofei/data/sj.png'"  /><h5>电商数据</h5></router-link></div>
                <div class="item item3"><router-link :to="{path:'/xfksh'}"><img :src="url+'/img/xaiofei/data/zb.png'"  /><h5>电商直播</h5></router-link></div>
                <!-- <div class="item item4">4</div>
                <div class="item item5">5</div>
                <div class="item item6">6</div> -->
              </div> 
            </div>
          </div>
          <img :src="url+'/img/xaiofei/data/lt.png'" class="centerImg2" />

          

        </div>
        <!-- 右侧 -->
        <div class="rightBox">
          <!-- 右一 -->
          <div class="rightBox1">
            <div class="title"><div class="titleBg">电商数据整体交易</div></div>
            <div class="rightcontent1A">
              <div class="rightcontent1AItem" v-for="(item,index) in rightData1" :key="index">
                <countTo :startVal="startVal" :endVal="item.value" :duration="1000" class="fontNum"></countTo>
                <img :src="url+'/img/xaiofei/data/dd.gif'" />
                <div>{{item.name}}</div>
              </div>
            </div>
            <div class="rightcontent1B">
              <div class="titleB"> 网销概览情况<span></span></div>
              <div class="rightcontent1BList">
                <div class="rightcontent1BItem" v-for="(item,index) in rightData2" :key="index">
                  <div class="rightcontent1BItem1">
                    <div class="rightcontent1BItem2" v-for="(item0,index0) in item" :key="index0"><span>{{item0.name}}</span><span>{{item0.value}}</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 右二 -->
          <div class="rightBox2">
            <div class="title"><div class="titleBg">电商数据实时分析</div></div>
            <div class="rightcontent2"><rightBar/></div>
          </div>
          <!-- 右三 -->
          <div class="rightBox3">
            <div class="title"><div class="titleBg">电商数据增长率</div></div>
            <div class="rightcontent3A">
              <div class="rightcontent3ALeft">
                <img :src="url+'/img/xaiofei/data/nq.png'" />
                <div class="circleContent"><span>+0.6%</span>今日</div>
              </div>
              <div class="rightcontent3ARight">
                <div class="line line1"></div>
                <div class="line line2"></div>
                <div class="rightcontent3ARightItrem" v-for="(item,index) in rightData3" :key="index"><span>{{item.name}}</span><span>{{item.value}}</span></div>
              </div>
            </div>
            <div class="rightcontent3B"><rightLine/></div>
          </div>
        </div>
      </div>
  </div>
   <footer1 />
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import * as THREE from 'three';
import { useRouter } from 'vue-router'
import countTo from"@/components/vue-count-to/src/vue-countTo.vue"
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
// 



import leftPie from "../components/xiaofeiData/leftPie.vue"
import leftLine from "../components/xiaofeiData/leftLine.vue"
import leftBar from "../components/xiaofeiData/leftBar.vue"
import rightBar from "../components/xiaofeiData/rightBar.vue"
import rightLine from "../components/xiaofeiData/rightLine.vue"
import footer1 from "../components/footer.vue";


export default {
  name: "Home",
  setup() {
    const { appContext  } = getCurrentInstance();
    const timer = ref(null);
    const router = useRouter();
    const state = reactive({
      url:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
      currentTime: "",
      isShow:false,
      config:{
        header: ['<span style="color:#038259;">网上名称</span>', '<span style="color:#038259;">归属地</span>', '<span style="color:#038259;">店铺数据</span>'],
        data: [
          ['河南来村科技有限公司','上蔡','8888'],
          ['某某有限公司','上蔡','8888'],
          ['某某有限公司','上蔡','8888'],
          ['河南来村科技有限公司','上蔡','8888'],
          ['某某有限公司','上蔡','8888'],
          ['河南来村科技有限公司','上蔡','8888'],
          ['某某有限公司','上蔡','8888'],
          ['某某有限公司','上蔡','8888'],
          ['河南来村科技有限公司','上蔡','8888'],
        ],
        headerBGC:"",
        oddRowBGC:"#04232C",
        evenRowBGC:"",
        // index: true,
        columnWidth: [150],
        align: ['center'],
        // rowNum:6
      },
      options: {
        src: "https://open.ys7.com/v3/openlive/K16315021_1_1.m3u8?expire=1720149435&id=598835193402363904&t=dd7e1a26c62914dfe12fd18a16926731e2f2ba7f55b28b3130a82a0e0e27af2c&ev=100", //视频源
        type: "m3u8", //视频类型
      },
      rightData1:[
        {name:"产品1",value:896756},
        {name:"产品2",value:96756},
        {name:"产品3",value:16756},
      ],
      startVal:0,//数字结束
      rightData2:[
        [{name:"网销下单",value:"58926"},{name:"可用率",value:"100%"}],
        [{name:"网销退单",value:"8926"},{name:"可用率",value:"100%"}]
      ],
      rightData3:[{name:"近三年平均增长速度",value:"1.2%"},{name:"电商消费系数",value:"80"}]
    });
    onMounted(() => {
      // init();
      // animate();
      // proxy.http()
      
      

    })
    onUnmounted(() => {
      // 清理资源
      // renderer.dispose();
    });
    onBeforeUnmount(() => {
      clearInterval(timer.value);
    })
     // 返回上一页
    function clickReturn(){
        router.go(-1);
    }
    function close(){
      state.isShow=!state.isShow
    }

    return {
      ...toRefs(state),
      close,
      clickReturn
    };
  },
  components: {
      leftPie,
      leftLine,
      leftBar,
      countTo,
      rightBar,
      rightLine,
      footer1
  },
};
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
@font-face {
  font-family: electronicFont;
  src: url("../assets/font/DS-DIGIT.TTF");
}

#video .d-player-wrap {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}
.container{
  width: 100%;
  height: 100%;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data/bj.jpg") no-repeat top center;
  background-size: 100% 100%;
  color: #fff;
  position: relative;
  .title0{
    width: 100%;
    height: 81px;
    background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/bt.png") no-repeat top center;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .return{
      width: 81px;
      height: 38px;
      cursor: pointer;
      margin-right: 50px;
      margin-top: 26px;
      position: relative;
      z-index: 999;
    }
    .return:first-child{
      margin-left: 50px;
    }
    .guang1{
      position: absolute;
      top: -34px;
      left: 0;
      animation: titleGuang1 2s linear infinite;
      z-index: 0;
    }
    .guang2{
      position: absolute;
      top: -34px;
      right: 0;
      animation: titleGuang2 2s linear infinite;
    }
    @keyframes titleGuang1{
      0%{
        left: 0;
      }
      100%{
        left: 15%;
      }
    }
    @keyframes titleGuang2{
      0%{
        right: 0;
      }
      100%{
        right: 15%;
      }
    }
  }
  .content{
    width: 100%;
    height: calc(100% - 81px);
    display: flex;
    position: relative;
    padding: 20px 50px;
    box-sizing: border-box;
    .navBox{
      position: absolute;
      left: 0;
      top: 0;
      width: 320px;
      height: 100%;
      z-index: 999;
      .navLeft{
        width: 320px;
        height: 100%;
        padding-right: 120px;
        display: flex;
        align-items: center;
        // justify-content: center;
        box-sizing: border-box;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/dh.png") no-repeat top center ;
        background-size: 100% 100%;
         position: relative;
         transition: all 1s ease-out;
        .leftLeft{ 
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-left: 10px;
          transition: all 1s ease-out;
          .btn{
            width: 147px;
            height: 53px;
            text-align: center;
            line-height: 53px;
            margin: 30px 0 0 0;
            font-size: 16px;
            cursor: pointer;
            transition: all 1s ease-out;
            animation: bianda 1s linear infinite;
            position: relative;
            span{
              position: absolute;
              top: 0;
              left: 0;
              display: block;
              width: 100%;
              height: 100%;

            }
          }
          .btn1,.btn:hover{
            background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/xz.png") no-repeat top center;
            color: #DBD600;
          }
          .btn2{
            background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/wxz.png") no-repeat top center;
            color: #9FEFEE;
          }
          .btn1:hover{
            position: relative;
            animation-play-state:paused;
            margin-bottom: 30px;
          }
        }
      .jiantou{
        width: 76px;
        height: 127px;
        position: absolute;
        right: 90px;
        animation: jiantou 1s linear infinite;
        cursor: pointer;
      }
      .jiantou1{
        transform: rotate(180deg);
      }
    }
    .left1{
      width: 160px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/dh.png") no-repeat center right;
      transition: all 1s ease-out; 
    }
    .leftLeft1{
      width: 0;
      overflow: hidden;
      .btn{width: 0;}
    }
    }
    .leftBox,.rightBox{
      width: 405px;
      height: 100%;
      padding: 12px 12px 0;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      height: 100%;
      position: relative;
      overflow: hidden;
      // border: 1px solid;
    }
    .leftBox{
      .leftBox1{
        height: 300px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        // .leftContent1A{
        //   width: 100%;
        //   flex: 1;
        // }
        //  .leftContent1B{
        //   width: 100%;
        //   flex: 1;
        // }
      }
      .leftBox2{
        flex: 1;
        margin: 20px 0;
        display: flex;
        flex-direction: column;
        // padding: 0 20px;
        .imgBox{
          display: flex;
          justify-content: center;
          height: 60px;
          img{
            width: 80px;
            margin: 0 20px;
          }
        }
        // .leftContent2{
        //   width: 100%;
        //   flex: 1;
          
        // }
      }
      .leftBox3{
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        width: 100%;
        flex: 1;
        box-sizing: border-box;
      }
      .leftContent{
          width: 100%;
          flex: 1;
      }

      
    }
    
    .center{
      flex: 1;
      height: 100%;
      position: relative;
      margin: 0 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .cernterBg{
        width: 644px;
        height: 643px;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data/dq.png") no-repeat;
        background-size: 100% 100%!important;
        // transform:scale(.9);
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -322px;
        .centerContent{
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          .centerImg{
            width: 279px;
            height: 295px;
          }
        }
        .centerContent::before{
          content: '';
          display:block;
          width: 50%;
          height: 50%;
          border-radius: 50%;
          opacity: .7;
          background-color: rgba(6,46,78,.5);
          animation: scale 3s infinite cubic-bezier(0,0,.49,1.02);
          // animation-delay: 100ms;
          position: absolute;
          top: 25%;
          left: 25%;
        }
      }
      .centerImg2{
          width: 358px;
          height: 252px;
          position: absolute;
          bottom:0;
          left: 50%;
          margin-left: -199px;
      }
      
    }
    // 右
    .rightBox{
      .rightBox1{
        height: 260px;
        display: flex;
        flex-direction: column;
        .rightcontent1A{
          width: 100%;
          display: flex;
          padding-top: 10px;
          height: 100px;
          box-sizing: border-box;
          .rightcontent1AItem{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            flex: 1;
            font-size: 16px;
            .fontNum{
              font-size: 20px;
              color: #fff;
              font-weight: bold;
              animation: bianda 1s  linear infinite;
              opacity: .8;
            }
            img{
              width: 111px;
              height: 53px;
              margin-top: -15px;
              animation: guangying 1s  linear infinite;
            }
          }
        }
        .rightcontent1B{
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          .titleB{
            position: relative;
            text-align: left;
            padding-left: 10px;
            display: flex;
            height: 20px;
            line-height: 20px;
            font-size: 14px;
            span{
              display: block;
              width: 50%;
              height: 1px;
              background: linear-gradient(to right,  #034033, rgba(3,64,51,0) 95%);
              position: relative;
              margin-top: 10px;
              margin-left: 30px;
            }
            span::before{
            content: "";
            position: absolute;
            left: 0;
            top: -3px;
            width: 6px;
            height: 6px;
            background:#034033 ;
            border-radius: 50%;
          }
          }
          .titleB::before{
            content: "";
            position: absolute;
            left: 0;
            top: 4px;
            width: 2px;
            height: 12px;
            background:#056F4E ;
          }
          .rightcontent1BList{
            flex: 1;
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
            .rightcontent1BItem{
              flex: 1;
              height: 100%;
              border: 1px solid #031821;
              padding: 5px;
              margin: 0 2%;
              .rightcontent1BItem1{
                width: 100%;
                height: 100%;
                border: 1px solid #0B564F;
                box-shadow: inset 0 0 5px 1px rgba(55, 199, 219, .5);
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                padding: 10px 0;
                box-sizing: border-box;
                .rightcontent1BItem2{
                  width: 100%;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  padding: 0 20px;
                  box-sizing: border-box;
                  line-height: 22px;
                    span{
                      display: block;
                      width: 100%;
                      text-align: left;  
                    }
                    span:first-child{
                      font-size: 14px;
                    }
                    span:last-child{
                      font-weight: bold;
                      font-size: 20px;
                      color: #057551;
                      letter-spacing: 2px;
                    }
                }
              }
            }
          }
        }
      }
      .rightBox2{
        height: 220px;
        display: flex;
        flex-direction: column;
        margin: 10px 0 15px;
        .rightcontent2{
          width: 100%;
          flex: 1;
        }
      }
      .rightBox3{
        display: flex;
        flex-direction: column;
        flex: 1;
        .rightcontent3A{
          height: 74px;
          width: 100%;
          display: flex;
          .rightcontent3ALeft{
            width: 74px;
            height: 74px;
            background:  url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data/wq.png") no-repeat top center;
            position: relative;
            img{
              position: absolute;
              top: 5px;
              left: 5px;
              width: 64px;
              height: 64px;
              animation: rightCircle 3s  linear infinite;
            }
            .circleContent{
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              font-size: 16px;
              span{
                display: block;
                font-size: 14px;
                line-height: 20px;
              }
            }
          }
          .rightcontent3ARight{
            height: 100%;
            flex: 1;
            position: relative;
            display: flex;
            justify-content: center;
            .rightcontent3ARightItrem{
              display: flex;
              flex-direction: column;
              justify-content: center;
              margin: 0 20px;
              font-size: 14px;
              span{
                display: block;
              }
              span:last-child{
                font-size: 18px;
                color: #056246;
                margin-top: 3px;
                font-weight: bold;
              }
            }
            .line{
              width: 100%;
              height: 2px;
              background: linear-gradient(to right,  #034033, rgba(3,64,51,0) 95%);
              position: absolute;
              left: -18px;
            }
            .line1{
              top: 5px;
            }
            .line2{
              bottom:5px;
            }
          }
        }
        .rightcontent3B{
          width: 100%;
          flex: 1;
        }
      } 
      
    }
    // 标题
    .title{
      width: 405px;
      height: 36px;
      line-height: 20px;
      text-align: left;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data/xbt.png") no-repeat ;
      padding-left: 30px;
      box-sizing: border-box;
      animation: title 3s linear infinite;
      display: flex;
      justify-content: space-between;
      .titleBg{
        font-size: 20px;
        // text-shadow: 0 0 1px rgba(75,180,229,.5);
        background: linear-gradient(to top,  #fff 25%, #fff 55%, rgba(14,197,236,0.8) 95%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-style: italic;
        letter-spacing: 2px;
        font-weight: bold;
      }
      img{
        height: 12px;
        margin-right: 20px;
        margin-top: 5px;
      }
    }

  }
}


// 轨道旋转动画b
@keyframes spin {
  0% {
    transform: scaleY(0.5) rotate(0deg);
  }
  100% {
    transform: scaleY(0.5) rotate(360deg);
  }
}
@keyframes anti-spin {
  0% {
    transform: rotate(0deg) scaleY(2) scale(1);
  }
  100% {
    transform: rotate(-360deg) scaleY(2) scale(1);
  }
}
// 轨道宽高
@w1: 700px;
@h1: 800px;
@r: @w1 / 2;
// 元素宽高
@w2: 169px;
@h2: 160px;
// 动画时间
@time: 30s;
// 元素个数
@num: 3;
.locateItem(@n, @i: 1) when (@i =< @n) {
  .item@{i} {
    @m: pi() / 180 * round(360 / @n) * @i;
    left: @r + @r * sin(@m) - @w2 / 2;
    bottom: @r + @r * cos(@m) - @h2 / 2;
  }
  .locateItem(@n, (@i + 1));
}
// // 旋转中心
// .center {
//   z-index: 999;
//   position: absolute;
//   top: 40px;
//   left: 120px;
//   width: 80px;
//   height: 80px;
//   background: yellow;
//   border-radius: 50%;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// }
// 轨道及元素
.orbit {
  position: absolute;
  top: -80px;
  left: -30px;
  width: @w1;
  height: @h1;
  border-radius: 50%;
  // background:url("../assets/img/xaiofei/data/lty.png") no-repeat top center;
  border: 2px dashed #197388;
  z-index: 900;
  animation: spin @time infinite linear;
  background-size: 100% 100%;
  .item {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: @w2;
    height: @h2;
    animation: anti-spin @time infinite linear;
    color: #fff;
    position: absolute;
    text-align: center;
    cursor: pointer;
    img{
      width: 169px;
      height: 124px;
    }
    a{
      color: #0DD1CA;
      text-decoration: none;
      font-size: 16px
    }
  }
  //   对每个元素进行定位
  .locateItem(@num);
}
// 鼠标悬停 动画暂停
.orbit:hover,
.orbit:hover .item,
.orbit .item:hover {
  animation-play-state: paused;
}

 @keyframes scale{
    0%{transform:scale(1)}
    50%,75%{transform:scale(2)}
    78%,100%{opacity:0}
}
@keyframes title {  
  0%{                     
      background-position: 0 bottom;
  } 
  50%{
    background-position: 10px bottom;
  }
   100%{
    background-position: 0 bottom;
  }
}
@keyframes bianda {  

  0%{                     
      // transform: scale(0.96);
      filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0));
  } 
  50%{
    // transform: scale(1);
    filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.5));
  }
   100%{
    // transform: scale(0.96);
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0));
  }
}
@keyframes jiantou {  

  0%{                     
      right: 90px;
  } 

  50%{
    right: 95px;
  }
   100%{
    right: 90px;
  }
}

@keyframes guangying {  
 0%{                     
      transform: scale(0.96);
      filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
  } 

  50%{
    transform: scale(1);
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));
  }
   100%{
    transform: scale(0.96);
    filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
  }
}


@keyframes rightCircle { 
  0% {
          transform: rotate(0deg);
      }

  100% {
      transform: rotate(360deg);
  }
}

 @keyframes rotate {
    0% {
        transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg);
    }
    100% {
        transform: rotateX(0deg) rotateY(0deg) rotateZ(360deg);
    }
 }

</style>
